// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__7VYGb","inputDescription":"styles_inputDescription__2t0Hy"};